module.exports = __webpack_public_path__ + "img/i-profil-mono.cfbfbc87.svg";